export default "__VITE_ASSET__BkfZ7WRt__"